import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from "@angular/material/dialog";
import { MatSnackBar, MatSnackBarModule } from "@angular/material/snack-bar";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormControl, FormBuilder, FormGroup, FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatSelectModule } from "@angular/material/select";
import { MatDividerModule } from "@angular/material/divider";
import { MatRadioModule } from "@angular/material/radio";
import { MatCardModule } from "@angular/material/card";
import { PinnedTripsService } from "../pinned-trips.service";

export interface PinnedTripsConfigData {
  currentMode: 'all' | 'pinned-only';
  pinnedCount: number;
}

export interface PinnedTripsConfigResult {
  mode: 'all' | 'pinned-only';
  clearAll?: boolean;
  clearedAll?: boolean;
}

@Component({
  selector: "app-pinned-trips-config-modal",
  templateUrl: "./pinned-trips-config-modal.component.html",
  styleUrls: ["./pinned-trips-config-modal.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatSnackBarModule,
    MatDividerModule,
    MatRadioModule,
    MatCardModule
  ],
})
export class PinnedTripsConfigModalComponent implements OnInit {
  selectedMode: 'all' | 'pinned-only';
  pinnedCount: number;
  isLoading = false;
  private tripsWereCleared = false;

  constructor(
    public dialogRef: MatDialogRef<PinnedTripsConfigModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PinnedTripsConfigData,
    private snackBar: MatSnackBar,
    private pinnedTripsService: PinnedTripsService
  ) {
    this.selectedMode = data.currentMode;
    this.pinnedCount = data.pinnedCount;
  }

  ngOnInit(): void {
  }

  onModeChange(mode: 'all' | 'pinned-only'): void {
    this.selectedMode = mode;
  }

  /**
   * Limpia todos los viajes pineados
   */
  onClearAll(): void {
    if (this.pinnedCount === 0) {
      this.snackBar.open('No hay viajes pineados para limpiar', 'Cerrar', { duration: 2000 });
      return;
    }

    this.isLoading = true;

    // Simular un pequeño delay para mejor UX
    setTimeout(() => {
      this.pinnedTripsService.clearAllPinnedTrips();
      this.pinnedCount = 0;
      this.selectedMode = 'all'; // Cambiar a modo "todos" cuando no hay pineados
      this.isLoading = false;
      this.tripsWereCleared = true; // Marcar que se limpiaron los viajes

      this.snackBar.open('Todos los viajes han sido despineados', 'Cerrar', { duration: 2000 });
    }, 500);
  }

  /**
   * Cancela y cierra el modal sin cambios
   */
  onCancel(): void {
    this.dialogRef.close();
  }

  /**
   * Guarda los cambios y cierra el modal
   */
  onSave(): void {
    const result: PinnedTripsConfigResult = {
      mode: this.selectedMode,
      clearAll: false,
      clearedAll: this.tripsWereCleared
    };

    this.dialogRef.close(result);
  }

  /**
   * Obtiene el texto descriptivo según el modo seleccionado
   */
  getModeDescription(): string {
    switch (this.selectedMode) {
      case 'all':
        return 'Se mostrarán todos los viajes con los pineados al inicio de la lista.';
      case 'pinned-only':
        return 'Solo se mostrarán los viajes que hayas marcado como pineados.';
      default:
        return '';
    }
  }

  /**
   * Verifica si se puede seleccionar el modo "solo pineados"
   */
  canSelectPinnedOnly(): boolean {
    return this.pinnedCount > 0;
  }
}